import { OnlyViewHoc } from 'hocs'
import React from 'react'

import { useLogisticFilialsFilters } from 'hooks/useLogisticFilialsFilters'
import { logisticFilialsApi } from 'redux/services/logistic-filial'
import { LogisticFilialReportType } from 'redux/services/logistic-filial/types'

import { AppButton } from 'components/AppButton'
import AppDatePicker from 'components/AppDatePicker/AppDatePicker'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'
import { TextField } from 'components/TextField'

import { LOGISTIC_FILIAL_STATUS_TEXT } from 'constants/logistic-filial'

interface Props {
  onSubmit?: () => void
  reset?: () => void
}

const defaultListValue = {
  title: 'Все',
  value: '',
}

export const Filters: React.FC<Props> = ({ onSubmit, reset }) => {
  const { data: branches = [] } =
    logisticFilialsApi.useGetLogisticFilialsBranchesQuery()
  const { params, setParam } = useLogisticFilialsFilters()
  const [downloadExcel, downloadExcelState] =
    logisticFilialsApi.useDownloadLogisticFilialExcelMutation()

  const statusList = Object.entries(LOGISTIC_FILIAL_STATUS_TEXT).map(
    ([value, title]) => ({
      title,
      value,
    }),
  )

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={onSubmit}>
            Применить
          </AppButton>
          <AppButton size="small" variant="red" onClick={reset}>
            Сбросить
          </AppButton>
          <OnlyViewHoc>
            <AppButton
              onClick={() => downloadExcel({ params })}
              disabled={downloadExcelState.isLoading}
              variant="siren_dashed_border"
              size="small"
            >
              Скачать отчет
            </AppButton>
            <AppButton
              onClick={() =>
                downloadExcel({
                  params,
                  type: LogisticFilialReportType.BY_USERS,
                })
              }
              disabled={downloadExcelState.isLoading}
              variant="siren_dashed_border"
              size="small"
            >
              Отчет по заявкам
            </AppButton>
          </OnlyViewHoc>
        </>
      }
    >
      <TextField
        inputSize="small"
        onChange={e => setParam('search', e.currentTarget.value)}
        value={params.search}
        name="search"
        label="Название"
        placeholder="Введите название"
      />

      <TextField
        inputSize="small"
        onChange={e => setParam('pan', e.currentTarget.value)}
        value={params.pan}
        name="pan"
        label="ПАН"
        placeholder="Введите ПАН"
      />

      <AppSelect
        size="extra_small"
        text={statusList.find(item => item.value === params.status)?.title}
        onChangeValues={value => setParam('status', value?.[0] || '')}
        list={[defaultListValue, ...statusList]}
        placeholder="Все"
        label="Статус"
      />

      <AppSelect
        size="extra_small"
        text={branches.find(item => item.id === Number(params.branch))?.name}
        onChangeValues={value => setParam('branch', value?.[0] || '')}
        list={[
          defaultListValue,
          ...branches.map(b => ({
            title: b.name,
            value: b.id,
          })),
        ]}
        placeholder="Все"
        label="Филиал/СК"
      />

      <AppDatePicker
        label="Начало"
        inputSize="small"
        value={params.start_date || ''}
        onchange={date => {
          setParam('start_date', date)
        }}
      />

      <AppDatePicker
        label="Конец"
        inputSize="small"
        value={params.end_date || ''}
        onchange={date => {
          setParam('end_date', date)
        }}
      />
    </AppFiltersLayout>
  )
}
